import axios from 'axios';
import store from './store';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const baseApiUrl = process.env.VUE_APP_API_URL;

const axiosConfigAD = {
  baseURL: baseApiUrl,
  timeout: 9000,
  withCredentials: true,
  cors: true,
  headers: {},
};

const apiad = ({ auth = null, headers = null } = {}) => {
  const apiad = axios.create(axiosConfigAD);
  return apiad;
};

export default apiad;
